import * as React from 'react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Button, Link } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Callout from 'modules/core/components/Callout'
import PanesHeader from 'modules/core/components/PanesHeader'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import AddBlockedPeriodModal from './Modals/AddBlockedPeriodModal'

export interface DescriptionProps {
  title: string
  description: string
  multigroup?: boolean
  helpCenterUrlName?: string
  onAddPolicy?: () => void
  defaultLeaveTypeId: string
  canManageTimeOff: boolean
}

const BlockedPeriodsDescription = ({
  title,
  description,
  multigroup,
  helpCenterUrlName,
  onAddPolicy,
  defaultLeaveTypeId,
  canManageTimeOff,
}: DescriptionProps) => {
  const { navigation } = useNavigation()

  const [showModal, setShowModal] = useState(false)
  const [showHelpTip, setShowHelpTip] = useState(true)
  const navigate = useNavigate()
  const onSuccess = (id: string) => {
    navigate(navigation.settings.timeoffPolicies.blockedPeriodsId.fullPath({ id }))
  }

  return (
    <Box>
      <PanesHeader illustration="calendar" title={title} description={description} />
      <Box gap="s24">
        {multigroup && (
          <Button type="secondary" onClick={onAddPolicy || (() => setShowModal(true))}>
            {i18n.t('settings.timeoff_blocked_periods.actions.add')}
          </Button>
        )}
        {showHelpTip && helpCenterUrlName && (
          <Box style={{ maxWidth: '500px' }}>
            <Callout
              type="info"
              title={i18n.t('settings.time_off.blocked_periods.need_help')}
              description={i18n.t('settings.time_off.blocked_periods.extra_info')}
              link={
                <Link.Href href={helpCenterUrlName} target="_blank" type="solid">
                  {i18n.t('settings.time_off.blocked_periods.learn_more')}
                </Link.Href>
              }
              onRemove={() => setShowHelpTip(false)}
            />
          </Box>
        )}
      </Box>
      {showModal && (
        <AddBlockedPeriodModal
          onClose={() => setShowModal(false)}
          onSuccess={onSuccess}
          defaultLeaveTypeId={defaultLeaveTypeId}
          canManageTimeOff={canManageTimeOff}
        />
      )}
    </Box>
  )
}

export default observer(BlockedPeriodsDescription)
